import { createFileRoute } from '@tanstack/react-router';
import { CostCentreRegister } from '../../../features/settings/components/CostCentreRegister';

/** Cost centre CRUD (BUILD_SPEC.md §5.1) — Dryer, Hammer Mills, PM1-3, Mobile
 * Plant, Site General, etc. per tenant. Plan.md G26. */
export const Route = createFileRoute('/_authenticated/settings/cost-centres')({
  component: CostCentreRegister,
});
